import { render, staticRenderFns } from "./RealtimeData.vue?vue&type=template&id=075c3965&scoped=true&"
import script from "./RealtimeData.vue?vue&type=script&lang=js&"
export * from "./RealtimeData.vue?vue&type=script&lang=js&"
import style0 from "./RealtimeData.vue?vue&type=style&index=0&id=075c3965&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "075c3965",
  null
  
)

export default component.exports